import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import MovimentacaoDevolucaoHttp from '../../../../../services/api/https/patrimonio/movimentacao-devolucao.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  CustomPanel,
  ImageContainer,
  Loading,
  PageHeader,
  UploadFileBtn,
} from '../../../../../components'

function UploadComprovante({ history, dispatch }) {
  const {
    location: {
      state: { movimentacao_id },
    },
  } = history

  const [movimentacao, setMovimentacao] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [cacheKey, setCacheKey] = useState(Date.now())

  useEffect(() => {
    getMovimentacao()
  }, [movimentacao_id])

  const onUploadCompleted = async file_name => {
    try {
      await MovimentacaoDevolucaoHttp.updatePathComprovante(movimentacao_id, file_name)
      setCacheKey(Date.now())
      await getMovimentacao()
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onDeleteComprovanteClicked = async () => {
    try {
      const path_array = movimentacao.path_comprovante.split('/')
      const file_name = path_array[path_array.length - 1]
      await MovimentacaoDevolucaoHttp.deleteComprovanteFile(file_name)
      await MovimentacaoDevolucaoHttp.updatePathComprovante(movimentacao_id, null)
      setMovimentacao({ ...movimentacao, path_comprovante: null })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const getMovimentacao = async () => {
    try {
      if (!movimentacao_id)
        throw new Error('Volte na tela anterior para selecionar a Movimentação desejada')
      const fetchedMovimentacao =
        await MovimentacaoDevolucaoHttp.getMovimentacaoDevolucaoById(movimentacao_id)
      setMovimentacao(fetchedMovimentacao)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  return (
    <React.Fragment>
      <PageHeader>
        Upload Comprovante - Patrimônio - Devolução &nbsp;
        <strong>{movimentacao ? movimentacao.id : ''}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            {!isLoading && !movimentacao.path_comprovante && (
              <div className="p-col-2" style={{ height: 50 }}>
                <UploadFileBtn
                  label="Upload Comprovante"
                  name="comprovante"
                  url={MovimentacaoDevolucaoHttp.urlUploadComprovante(movimentacao_id)}
                  onUploadCompleted={onUploadCompleted}
                />
              </div>
            )}
            <div className="p-col-12">
              {isLoading ? (
                <div className="text-center">
                  <Loading />
                </div>
              ) : movimentacao.path_comprovante ? (
                <ImageContainer
                  imagePath={`${movimentacao.path_comprovante}?t=${cacheKey}`}
                  alt="Comprovante"
                  onBtnDeleteClicked={onDeleteComprovanteClicked}
                />
              ) : null}
            </div>
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(UploadComprovante))
